import api from '@/services/Api'

export default{
  getMediaProperties (mediaName) {
    return api().post('getmediaproperties', mediaName)
  },
  registerMediaProperties (mediaProperties) {
    return api().post('registermediaproperties', mediaProperties)
  },
  updateMediaProperties (mediaProperties) {
    return api().post('updatemediaproperties', mediaProperties)
  },
  registerMediaPropertiesCultura (mediaProperties) {
    return api().post('registermediapropertiestocultura', mediaProperties)
  },
  updateMediaPropertiesCultura (mediaProperties) {
    return api().post('updatemediapropertiestocultura', mediaProperties)
  }
}
